import { Box, Container } from '@material-ui/core'
import { useEffect, useMemo, useState } from 'react'
import { Helmet } from 'react-helmet'
import { useDispatch } from 'react-redux'
import { useLocation } from 'react-router'
import AddUpdateDialog from 'src/components/common/addUpdateDialog'
import FilterSection from 'src/components/common/filterSection'
import PlayerComponent from 'src/components/helperComponents/PlayerComponent'
import AddEditVideoCategory from 'src/components/Videos/AddEditVideosCategory'
import useQueryTable from 'src/hooks/useQueryTable'
import { DeleteVideoCategoryById } from 'src/redux/actions'
import { LocalTable } from 'src/ui/Table'
import { GetVideoCategoryColumns } from 'src/util/columns'

const VideoCategoryList = () => {
    const dispatch = useDispatch()
    const location = useLocation();
    const [additionalFilters, setAdditionalFilters] = useState({
        sort: "-createdAt",
    });
    const [recordToEdit, setRecordToEdit] = useState()
    const [mediaUrl, setMediaUrl] = useState()
    const [searchText, setSearchText] = useState(null)

    const [{ pageIndex, pageSize }, setPagination] = useState({
        pageIndex: 0,
        pageSize: 10,
    })

    // useEffect(() => {
    //   dispatch(GetEntertainmentVideos())
    // }, [])

    const columns = useMemo(() => GetVideoCategoryColumns(), [])

    const { data, isLoading, isFetching, refetch } = useQueryTable({
        name: "videoCategories",
        searchText,
        pageIndex,
        pageSize,
        additionalFilters,
    });

    // Parse and update filters only when needed
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const categoryId = params.get("_id") || " ";

        setAdditionalFilters((prev) => {
            return { ...prev, _id: categoryId };
        });
    }, [location.search]);

    // Function for delete Video category by id
    const onDeleteRow = async (recordToDelete) => {
        await dispatch(DeleteVideoCategoryById(recordToDelete));
        refetch();
    }

    return (
        <>
            <Helmet>
                <title>Video Categories | Langistan</title>
            </Helmet>
            <Box
                sx={{
                    backgroundColor: 'background.default',
                    minHeight: '100%',
                    py: 3,
                }}
            >
                <Container maxWidth={false}>

                    {/* addButton filters & search section  */}
                    <FilterSection
                        type="Videos Category"
                        setSearchText={setSearchText}
                        setRecordToEdit={setRecordToEdit}
                    />

                    {/* Videos list Data */}
                    <Box sx={{ pt: 3 }}>
                        <LocalTable
                            columns={columns}
                            onEditClick={setRecordToEdit}
                            onDeleteClick={onDeleteRow}
                            // additionalFilters={customFilterQuery}
                            data={data}
                            name="Video Category"
                            isLoading={isLoading}
                            isFetching={isFetching}
                            setPagination={setPagination}
                        />
                    </Box>

                    {mediaUrl && (
                        <PlayerComponent
                            url={mediaUrl}
                            onDialogCancel={() => setMediaUrl()}
                        />
                    )}

                    {/* Add & Update Video category*/}
                    <AddUpdateDialog
                        open={!!recordToEdit}
                        title={`${Object.keys(recordToEdit ?? {}).length ? "Update" : "Create"} Videos Category`}
                        onClose={() => {
                            setRecordToEdit();
                        }
                        }
                        maxWidth="sm"
                    >
                        <AddEditVideoCategory
                            selectedRow={recordToEdit}
                            toggleDrawer={() => setRecordToEdit()}
                            refetch={refetch}
                        />
                    </AddUpdateDialog>

                </Container>
            </Box>
        </>
    )
}

export default VideoCategoryList
